var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 17.5,
    viewBox: "0 0 20 17.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M10 0C10.599 0.0260417 11.0547 0.286458 11.3672 0.78125L19.8047 15.1562C20.0651 15.6771 20.0651 16.1979 19.8047 16.7188C19.4922 17.2135 19.0365 17.474 18.4375 17.5H1.5625C0.963542 17.474 0.507812 17.2135 0.195312 16.7188C-0.0651042 16.1979 -0.0651042 15.6771 0.195312 15.1562L8.67188 0.78125C8.98438 0.286458 9.42708 0.0260417 10 0V0V0M10 5C9.42708 5.05208 9.11458 5.36458 9.0625 5.9375V10.3125C9.11458 10.8854 9.42708 11.1979 10 11.25C10.5729 11.1979 10.8854 10.8854 10.9375 10.3125V5.9375C10.8854 5.36458 10.5729 5.05208 10 5V5V5M11.25 13.75C11.25 13.3854 11.1328 13.0859 10.8984 12.8516V12.8516C10.6641 12.6172 10.3646 12.5 10 12.5C9.63542 12.5 9.33594 12.6172 9.10156 12.8516C8.86719 13.0859 8.75 13.3854 8.75 13.75C8.75 14.1146 8.86719 14.4141 9.10156 14.6484C9.33594 14.8828 9.63542 15 10 15C10.3646 15 10.6641 14.8828 10.8984 14.6484C11.1328 14.4141 11.25 14.1146 11.25 13.75V13.75V13.75",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatWarning);
export default __webpack_public_path__ + "static/media/stat-warning.0861c20a6b10075d70080f231bc78973.svg";
export { ForwardRef as ReactComponent };